import { initializeApp } from 'firebase/app'
import { connectFunctionsEmulator, getFunctions, type Functions } from 'firebase/functions'
import { DEFAULT_CALLABLE_REGION, type CallableRegion } from '~/utils/callableRegions'

export default defineNuxtPlugin(() => {
  const config = useRuntimeConfig()

  const app = initializeApp({
    apiKey: config.public.firebaseApiKey as string,
    authDomain: config.public.firebaseAuthDomain as string,
    projectId: config.public.firebaseProjectId as string,
    storageBucket: config.public.firebaseStorageBucket as string,
    messagingSenderId: config.public.firebaseMessagingSenderId as string,
    appId: config.public.firebaseAppId as string,
    measurementId: config.public.firebaseMeasurementId as string,
  })
  // Local Flash Pay validation only (plan 1, Task 14): NUXT_PUBLIC_FUNCTIONS_EMULATOR=127.0.0.1:5002
  const emulator = config.public.functionsEmulator as string | undefined
  function connect(instance: Functions): Functions {
    if (emulator) {
      const [host, port] = emulator.split(':')
      connectFunctionsEmulator(instance, host ?? '127.0.0.1', Number(port))
    }
    return instance
  }
  const functions = connect(getFunctions(app))
  // One instance per other region, made on first use (utils/callableRegions.ts says which callables need one).
  const regional = new Map<CallableRegion, Functions>([[DEFAULT_CALLABLE_REGION, functions]])
  function functionsIn(region: CallableRegion): Functions {
    let instance = regional.get(region)
    if (!instance) {
      instance = connect(getFunctions(app, region))
      regional.set(region, instance)
    }
    return instance
  }

  return {
    provide: {
      firebaseApp: app,
      firebaseFunctions: functions,
      firebaseFunctionsIn: functionsIn,
    },
  }
})
